/**
 * @generated SignedSource<<3dc273fc0b456a05c82d4ccdbcf22cb6>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type NavItemVATReportLink_navItem$data = {
  readonly dataTn: string | null;
  readonly eventName: string | null;
  readonly href: string | null;
  readonly interactionType: string | null;
  readonly title: string | null;
  readonly " $fragmentSpreads": FragmentRefs<"NavItem_navItem">;
  readonly " $fragmentType": "NavItemVATReportLink_navItem";
};
export type NavItemVATReportLink_navItem$key = {
  readonly " $data"?: NavItemVATReportLink_navItem$data;
  readonly " $fragmentSpreads": FragmentRefs<"NavItemVATReportLink_navItem">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "NavItemVATReportLink_navItem",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "NavItem_navItem"
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "eventName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "interactionType",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "href",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "dataTn",
      "storageKey": null
    }
  ],
  "type": "NavBarElement",
  "abstractKey": "__isNavBarElement"
};

(node as any).hash = "5324553f7c29101b7b310dddbeb7fb3e";

export default node;
